import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function BannerTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-snug overflow-hidden" data-testid="resume-live-preview">
      <div className="p-8 text-center" style={{ backgroundColor: accent }}>
        <h1 className="text-2xl font-bold text-white tracking-wide">{draft.full_name || "Your Name"}</h1>
        {draft.target_role && <p className="text-white/85 text-xs mt-1 font-semibold uppercase tracking-wider">{draft.target_role}</p>}
        <p className="text-white/70 text-[11px] mt-1.5">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join(" | ")}</p>
      </div>
      <div className="p-7">
        {draft.summary && (
          <div>
            <h2 className="text-xs font-bold uppercase tracking-wider flex items-center gap-2" style={{ color: accent }}>
              <span className="w-4 h-[2px]" style={{ backgroundColor: accent }} /> Summary
            </h2>
            <p className="text-slate-700 mt-1.5">{draft.summary}</p>
          </div>
        )}
        {draft.skills.length > 0 && (
          <div className="mt-4 flex flex-wrap gap-1.5">
            {draft.skills.map((sk) => (
              <span key={sk} className="text-[11px] font-medium px-2.5 py-1 rounded-full" style={{ backgroundColor: `${accent}15`, color: accent }}>{sk}</span>
            ))}
          </div>
        )}
        {draft.experience.length > 0 && (
          <div className="mt-5">
            <h2 className="text-xs font-bold uppercase tracking-wider flex items-center gap-2" style={{ color: accent }}>
              <span className="w-4 h-[2px]" style={{ backgroundColor: accent }} /> Experience
            </h2>
            {draft.experience.map((e, i) => (
              <div key={i} className="mt-2.5 pl-3 border-l-2" style={{ borderColor: `${accent}40` }}>
                <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
                <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
              </div>
            ))}
          </div>
        )}
        {draft.education.length > 0 && (
          <div className="mt-5">
            <h2 className="text-xs font-bold uppercase tracking-wider flex items-center gap-2" style={{ color: accent }}>
              <span className="w-4 h-[2px]" style={{ backgroundColor: accent }} /> Education
            </h2>
            {draft.education.map((ed, i) => (
              <p key={i} className="text-slate-700 mt-1.5"><span className="font-semibold text-slate-800">{ed.degree} {ed.field}</span> — {ed.school} <span className="text-slate-400 italic">({ed.start_date} - {ed.end_date})</span></p>
            ))}
          </div>
        )}
        <ExtraResumeSections draft={draft} accent={accent} />
      </div>
    </div>
  );
}
